import {SET_FINAL_ORDER, SET_MATCHING} from '../types';
import BN from 'bn.js';
import {Decimal} from 'decimal.js';
import {toUnit,fromUnit} from '../../config';

export function removeTaker(index,onlyChangeTaker){
  return function(dispatch,getState){
    let takeOrders = getState().ui_marketplace.takeOrders
    let order = takeOrders[index]
    takeOrders.splice(index,1)
    if(onlyChangeTaker){
      dispatch({
        type: SET_FINAL_ORDER,
        payload:{
          takeOrders
        }
      });
    }
    else {
      dispatch({
        type: SET_FINAL_ORDER,
        payload:{
          takeOrders,
          makerAmount: new Decimal(getState().ui_marketplace.makerAmount).add(new Decimal(order.takeAmount)).toNumber(),
          takerCollateral:new Decimal(getState().ui_marketplace.takerCollateral).sub(new Decimal(order.takeCollateral)).toNumber(),
          makerCollateral: new Decimal(getState().ui_marketplace.makerCollateral).add(new Decimal(order.takeCollateral)).toNumber()
        }
      });
    }
  }
}


export function matchOrdersDispatch(dispatch,getState,done){
  try {
    if(!getState().ui_marketplace.price || !getState().ui_marketplace.amount || getState().ui_marketplace.price === 0 || getState().ui_marketplace.amount === 0){
      dispatch({type:SET_MATCHING,payload:false})

      dispatch({
        type: SET_FINAL_ORDER,
        payload:{takeOrders:[],makerAmount:0,takerCollateral:0,makerCollateral:0,spending:0}
      });
      done()

      return;
    }

    let price = new Decimal(getState().ui_marketplace.price)
    let amount = new Decimal(getState().ui_marketplace.amount)
    let tempAmount = new Decimal(getState().ui_marketplace.amount);

    // if(getState().ui_marketplace.market.denomination.toUpperCase() === 'NRG')
    // tempAmount = tempAmount * price;
    let ids = [];
    let summedCollateral = new Decimal(0);

    let orderType = getState().ui_marketplace.orderType;
    let orders = orderType === "SELL" ? getState().orderbook.sub_demand : getState().orderbook.sub_offers;
    orders = orders.reduce((total,curr)=>{return total.concat(curr.orders)},[]).filter((o)=>{return o!=undefined && !o.mempool})

    if(orderType === "BUY") orders.sort((a,b)=> a.price - b.price);
    else orders.sort((a,b)=> b.price - a.price);


    for(let i = 0; i < orders.length; i++){
      let order = orders[i];
      let priceAcceptable = (orderType === "SELL" && order.price >= price.toNumber()) || (order.price <= price.toNumber() && orderType === "BUY" );
      let oAmount = new Decimal(order.amount)
      let oo = new Decimal(order.a);
      let oPrice = new Decimal(order.price)
      let oCol = new Decimal(order.collateralizedNrg)
      if(!priceAcceptable) break;
      if(priceAcceptable && tempAmount.gt(new Decimal(0))){
        // let ratio = new Decimal(order.nrgUnit).div(new Decimal(order.collateralizedNrg))
        let ratio = new Decimal(order.nrgUnit).div(new Decimal(order.originalNrg))

        if(oAmount.gt(tempAmount)) {
          let takeAmount = oAmount;
          while(takeAmount.gt(tempAmount)){
            takeAmount = takeAmount.sub(ratio.mul(oo))
          }
          if(takeAmount.eq(new Decimal(0))) continue;
          order.takeAmount = takeAmount;
          order.takeCollateral = oCol.mul(order.takeAmount.div(oAmount));
        }
        else {
          order.takeAmount = oAmount
          order.takeCollateral = oCol
        }

        if(order.fixedUnitFee.toString() !== '0') {
          order.takeCollateral = new Decimal(order.fixedUnitFee);
        }

        let sendAmount = new Decimal(order.receivesUnit).mul(order.takeAmount.div(oAmount)).toString()
        let recAmount = new Decimal(order.sendsUnit).mul(order.takeAmount.div(oAmount)).toString()

        let recUnit = Math.floor(toUnit(order.sendsFromChain,recAmount))
        let sendUnit = Math.floor(toUnit(order.receivesToChain,sendAmount))

        sendAmount = fromUnit(order.receivesToChain,sendUnit)
        recAmount = fromUnit(order.sendsFromChain,recUnit)

        tempAmount = tempAmount.sub(order.takeAmount);
        summedCollateral = summedCollateral.add(order.takeCollateral)
        order.takeAmount = order.takeAmount.toString()
        order.takeCollateral = order.takeCollateral.toString()
        order.sendAmount = sendAmount;
        order.recAmount = recAmount;
        ids.push(order);
      }
    }
    if(orderType == 'SELL' && getState().ui_marketplace.market.denomination.toUpperCase() === "NRG") tempAmount = new Decimal(0);
    let makerCollateral = price.mul(tempAmount);

    if(getState().ui_marketplace.market.denomination.toUpperCase() !== "NRG"){
      let nrgPrice =
      new Decimal(getState().price.btc).div(new Decimal(getState().orderbook.matched_pairs[`auction`][`BTC/NRG`].lastPrice.price)) ;
      if(nrgPrice.eq(new Decimal(Infinity))) nrgPrice = 0.10;

      if(['DAI','USDT'].includes(getState().ui_marketplace.market.denomination.toUpperCase())){
        makerCollateral = makerCollateral.div(new Decimal(nrgPrice))
      }
      else {
        makerCollateral = makerCollateral.div(new Decimal(nrgPrice)).mul(getState().price[getState().ui_marketplace.market.denomination.toLowerCase()])
      }
    }
    else {
      makerCollateral = new Decimal(0.1);
    }

    dispatch({
      type: SET_FINAL_ORDER,
      payload:{
        takeOrders:ids,
        makerAmount:tempAmount.toNumber(),
        takerCollateral:summedCollateral.toNumber(),
        makerCollateral: makerCollateral.toNearest(0.001)
      }
    });
    dispatch({type:SET_MATCHING,payload:false})
    done()
    return;
  }
  catch(err){
    dispatch({type:SET_MATCHING,payload:false})
    done()
    console.log({err})
  }
}

export function matchOrders(done){
  return function(dispatch,getState){
    dispatch({type:SET_MATCHING,payload:true})
    matchOrdersDispatch(dispatch,getState,()=>{
      setTimeout(()=>{
        done()
      },100)
    })
  }
}
